module.exports = "/_next/static/images/video_id_7136967940838116651-59457cc530960e641fcb86f0eee8cb74.jpg";